/* eslint-disable prefer-destructuring */
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import './_layout.scss';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Header } from 'components/common/header';
import { Footer } from 'components/common/footer';
import { Container } from 'components/layout/Container';
import { AnchorLink } from 'components/atoms/AnchorLink/AnchorLink';
import { trackProductPageView } from 'libs/adobeAnalytics';
import LoaderSpinner from 'components/atoms/Loader/LoaderSpinner';

export function Layout() {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const { userInfo } = useSelector((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;

      const atBottom = scrollTop + clientHeight >= scrollHeight - 85;
      setIsAtBottom(atBottom);

      setHasScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!userInfo) return;

    const timeout = setTimeout(() => {
      // Prevent page view event to fire twice on page load
      if (!document.title.includes('Shop - Roland Cloud')) {
        trackProductPageView(userInfo);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [location, userInfo]);

  if (!userInfo) return <LoaderSpinner />;

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <a
        href='#main-content'
        className='sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[10001] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black'
      >
        Skip to main content
      </a>
      <Header />
      <main className='main scroll-mt-24' id='main-content' tabIndex={-1}>
        <Container>
          <Outlet />
          <ScrollRestoration />
        </Container>
      </main>

      {hasScrolled ? <AnchorLink /> : null}
      <Footer isAtBottom={isAtBottom} />
    </div>
  );
}
